import { ref } from 'vue';
import { defineStore } from 'pinia';
import { UserInfo } from './UserInfo';

export const useUserInfoStore = defineStore('userInfo', () => {
  const currentUser = ref<UserInfo | undefined>(undefined);

  // Only for Dev/Local env. risk mitigation
  const token = ref<string>('');

  const setUserInfo = (user: UserInfo) => {
    currentUser.value = user;
  };

  const setToken = (jwt: string) => {
    token.value = jwt;
  };

  const reset = () => {
    currentUser.value = undefined;
    token.value = '';
  };

  const toString = () => {
    if (currentUser.value) {
      const expiry = currentUser.value.expiry ? new Date(currentUser.value.expiry).toISOString() : 'not set';
      return JSON.stringify({ name: currentUser.value.name, role: currentUser.value.role, expiry: expiry });
    } else {
      return '';
    }
  };

  return {
    currentUser,
    token,
    setUserInfo,
    setToken,
    reset,
    toString
  };
});
